const bind = function () {
  const siteKey = "6Lfi2ncbAAAAAM5HdzMrDNcSkFpmh0ARSsU81BRx";

  $('form[name="contactForm"]').on("submit", function (e) {
    e.preventDefault();

    grecaptcha.ready(function () {
      grecaptcha.execute(siteKey, { action: "submit" }).then(function (token) {
        $('form[name="contactForm"]')
          .children('input[name="g-recaptcha-response"]')
          .val(token);
        $('form[name="contactForm"]').off("submit").trigger("submit");
      });
    });
  });

  $('form[name="loginForm"]').on("submit", function (e) {
    e.preventDefault();

    grecaptcha.ready(function () {
      grecaptcha.execute(siteKey, { action: "submit" }).then(function (token) {
        $('form[name="loginForm"]')
          .children('input[name="g-recaptcha-response"]')
          .val(token);
        $('form[name="loginForm"]').off("submit").trigger("submit");
      });
    });
  });

  $('form[name="Form"]').on("submit", function (e) {
    e.preventDefault();

    grecaptcha.ready(function () {
      grecaptcha.execute(siteKey, { action: "submit" }).then(function (token) {
        $('form[name="Form"]')
          .children('input[name="g-recaptcha-response"]')
          .val(token);
        $('form[name="Form"]').off("submit").trigger("submit");
      });
    });
  });


  $('form[name="dsaForm"], form[name="psirtForm"], form[name="franczyzaForm"]').on("submit", function (e) {
    e.preventDefault();
    const $form = $(this);

    grecaptcha.ready(function () {
      grecaptcha.execute(siteKey, { action: "submit" }).then(function (token) {
        $form.children('input[name="g-recaptcha-response"]').val(token);
        $form.off("submit").trigger("submit");
      });
    });
  });

  $('form[name="registerForm"]').on("submit", function (e) {
    e.preventDefault();

    grecaptcha.ready(function () {
      grecaptcha.execute(siteKey, { action: "submit" }).then(function (token) {
        $('form[name="registerForm"]')
          .children('input[name="g-recaptcha-response"]')
          .val(token);
        $('form[name="registerForm"]').off("submit").trigger("submit");
      });
    });
  });
};

export { bind };
